import { SeanceActions } from '../constants';
import { QueryParams, QueryMultiParams } from 'src/types/grid';
import { SeanceFormData } from 'src/screens/General/screens/Cases/screens/CaseCalendarScreen/components/EventForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { successType } from '../../services/api-handlers/api-resolver';

export interface GetSeancesAction {
    type: typeof SeanceActions.FETCH_SEANCES;
    payload: QueryParams;
    all?: any;
}
export function getSeances(params: QueryParams): GetSeancesAction {
    return {
        type: SeanceActions.FETCH_SEANCES,
        payload: params,
    };
}

export interface GetSeancesListAction {
    type: typeof SeanceActions.FETCH_SEANCES_LIST;
    payload: QueryParams;
    all?: any;
}
export function getSeancesList(params: QueryParams): GetSeancesListAction {
    return {
        type: SeanceActions.FETCH_SEANCES_LIST,
        payload: params,
    };
}
export function getSeancesEmpty(params: any): GetSeancesAction {
    return {
        type: successType(SeanceActions.FETCH_SEANCES),
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getSeancesCsv(params: QueryParamsAll): GetSeancesAction {
    return {
        type: SeanceActions.FETCH_SEANCES_CSV,
        payload: params,
        all: params.all,
    };
}

export function getUnconfirmedSeances(params: QueryParams): GetSeancesAction {
    return {
        type: SeanceActions.FETCH_UNCONFIRMED_SEANCES,
        payload: params,
    };
}
export interface GetMultiSeancesAction {
    type: typeof SeanceActions.FETCH_MULTI_SEANCE;
    payload: QueryMultiParams;
}

export function getMultiSeances(params: QueryMultiParams): GetSeancesAction {
    return {
        type: SeanceActions.FETCH_MULTI_SEANCE,
        payload: params,
    };
}

export interface GetSeancesStatisticsAction {
    type: typeof SeanceActions.FETCH_SEANCE_STATISTICS;
    payload: {
        params: any;
    };
}

export function getSeancesStatistics(params: any): GetSeancesStatisticsAction {
    return {
        type: SeanceActions.FETCH_SEANCE_STATISTICS,
        payload: {
            params,
        },
    };
}

export interface GetSeanceAction {
    type: typeof SeanceActions.FETCH_SEANCE;
    payload: {
        id: string | number;
    };
}

export interface GetCopySeanceAction {
    type: typeof SeanceActions.COPY_NOTE_SEANCE;
    payload: {
        id: string | number;
    };
}

export function getSeance(id: string | number): GetSeanceAction {
    return {
        type: SeanceActions.FETCH_SEANCE,
        payload: { id },
    };
}

export function getCopySeance(id: string | number): GetCopySeanceAction {
    return {
        type: SeanceActions.COPY_NOTE_SEANCE,
        payload: { id },
    };
}

export interface DeleteSeanceAction {
    type: typeof SeanceActions.DELETE_SEANCE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteSeance(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteSeanceAction {
    return {
        type: SeanceActions.DELETE_SEANCE,
        payload: { id, onSuccess, onError },
    };
}

export interface DeleteFileSeanceAction {
    type: typeof SeanceActions.DELETE_FILE_SEANCE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileSeance(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileSeanceAction {
    return {
        type: SeanceActions.DELETE_FILE_SEANCE,
        payload: { id, onSuccess, onError },
    };
}

export interface CreateFilesSeanceAction {
    type: typeof SeanceActions.CREATE_FILES_SEANCE;
    payload: {
        id: number | string;
        requestType: string;
        files: any;
        isDatasheet: boolean;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createFilesSeance(
    id: number | string,
    requestType: string,
    files: any,
    isDatasheet: boolean,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateFilesSeanceAction {
    return {
        type: SeanceActions.CREATE_FILES_SEANCE,
        payload: {
            id,
            requestType,
            files,
            isDatasheet,
            onSuccess,
            onError,
        },
    };
}

export interface GetFilesAction {
    type: typeof SeanceActions.FETCH_FILES_SEANCE;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: SeanceActions.FETCH_FILES_SEANCE,
        payload: { id },
    };
}

export interface PersistSeanceAction {
    type: typeof SeanceActions.PERSIST_SEANCE;
    payload: {
        data: SeanceFormData;
        files: any;
        callbacks: SagaPromise<any>;
        resF?: any;
    };
}

export function updateSeanceNote(data: any, files: any, callbacks: SagaPromise<any>): PersistSeanceAction {
    return {
        type: SeanceActions.UPDATE_SEANCE_NOTE,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export function updateSeanceInTime(data: any, files: any, callbacks: SagaPromise<any>): PersistSeanceAction {
    return {
        type: SeanceActions.UPDATE_SEANCE_IN_TIME,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export function updateSeanceLocation(data: any, files: any, callbacks: SagaPromise<any>): PersistSeanceAction {
    return {
        type: SeanceActions.UPDATE_LOCATION,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export function persistSeance(
    data: SeanceFormData,
    files: any,
    callbacks: SagaPromise<any>,
    resF?: any,
): PersistSeanceAction {
    return {
        type: SeanceActions.PERSIST_SEANCE,
        payload: {
            data,
            files,
            callbacks,
            resF,
        },
    };
}

export const asyncPersistSeance = (data: any, files: any, dispatch: Dispatch, resF?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        return dispatch(persistSeance(data, files, { resolve, reject }, resF));
    });
};

export interface MoveToOccasionSeanceAction {
    type: typeof SeanceActions.MOVE_TO_OCCASION_SEANCE;
    payload: {
        data: Partial<{ id: string | number; occasion: string | number }>;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function moveToOccasionSeance(
    data: Partial<{ id: string | number; occasion: string | number }>,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): MoveToOccasionSeanceAction {
    return {
        type: SeanceActions.MOVE_TO_OCCASION_SEANCE,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}

export interface UpdateSeanceAction {
    type: typeof SeanceActions.UPDATE_SEANCE;
    payload: {
        data: Partial<SeanceFormData>;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function updateSeance(
    data: Partial<SeanceFormData>,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): UpdateSeanceAction {
    return {
        type: SeanceActions.UPDATE_SEANCE,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}

export interface SignSeanceAction {
    type: typeof SeanceActions.SIGN_SEANCE;
    payload: {
        data: Partial<{ id: string | number; seanceFuture: boolean }>;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function signSeance(
    data: Partial<{ id: string | number; seanceFuture: boolean }>,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): SignSeanceAction {
    return {
        type: SeanceActions.SIGN_SEANCE,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}
export type Actions =
    | GetSeancesAction
    | GetSeancesListAction
    | GetSeanceAction
    | GetCopySeanceAction
    | DeleteSeanceAction
    | PersistSeanceAction
    | MoveToOccasionSeanceAction
    | SignSeanceAction
    | GetMultiSeancesAction
    | UpdateSeanceAction;
